import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__-iuIi","backdrop":"styles_backdrop__HZTyd","visible":"styles_visible__uYSi1","header":"styles_header__LDHYG","body":"styles_body__R6XEy"};
export const b = b_.with('overlay');